import React from "react";
import "react-dates/initialize";
import "./_datepicker.css";
import moment from "moment";
import { DateRangePicker } from "react-dates";

class DateRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
    };
  }
  s;
  focusChange = (focusedInput) => {
    this.setState({ focusedInput });
  };

  render() {
    const { dates, filter, updateDates } = this.props;
    const { startDate, endDate } = dates;
    return (
      <DateRangePicker
        startDate={startDate ? moment(startDate) : null}
        startDateId="start-date"
        endDate={endDate ? moment(endDate) : null}
        endDateId="end-date"
        onDatesChange={updateDates}
        focusedInput={this.state.focusedInput}
        onFocusChange={this.focusChange}
        numberOfMonths={1}
        isOutsideRange={(day) => day.isAfter(moment())}
        appendToBody={filter}
        anchorDirection={filter ? "right" : "left"}
        small
        showDefaultInputIcon
        hideKeyboardShortcutsPanel
        showClearDates
      />
    );
  }
}

export default DateRange;
